import axios from 'axios';

export interface MemberList {
    id: number;
    name: string;
}

export interface Package {
    packageId: string;
    packageName: string;
}

// 1. Create Member List
export const createMemberList = async (courseName: string) => {
    const response = await axios.post(`${process.env.REACT_APP_BASE_API_URL}/v2/member/memberlist`, {
        memberListName: courseName,
    });
    return response.data;
};

// 2. Get Member List by filter
export const getMemberList = async (filter: string) => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_API_URL}/v2/member/memberlist`, {
        params: { filter, pageNo: 1, pageSize: 10 },
    });
    return response.data;
};

// 3. Create Package for a Channel
export const createPackage = async (courseName: string, channelId: string) => {
    const response = await axios.post(`${process.env.REACT_APP_BASE_API_URL}/v2/monetization/package`, {
        name: courseName,
        channelId,
    });
    return response.data;
};

// 4. Assign Member List to Package
export const assignMemberListToPackage = async (
    packageId: string,
    memberListId: number
) => {
    const response = await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/v2/monetization/package/${packageId}/memberlist/${memberListId}`
    );
    return response.data;
};

// 5. Upload emails to Member List
export const uploadEmailsToMemberList = async (
    memberListId: number,
    emails: string[]
) => {
    // encode as comma-separated %2C
    const values = encodeURIComponent(emails.join('; '));
    const response = await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/v2/member/memberlist/${memberListId}?type=0`,
        {
            Values: values,
        }
    );
    return response.data;
};

export const setupCourseRegistrationFlow = async (
    courseName: string,
    channelId: string
) => {
    try {
        // 1. Create member list
        await createMemberList(courseName);

        // 2. Get member list back
        const memberListData = await getMemberList(courseName);
        const memberListId = memberListData.result[0].id;

        // 3. Create package
        const packageData = await createPackage(courseName, channelId);
        const packageId = packageData.result.packageId;

        // 4. Assign member list to package
        await assignMemberListToPackage(packageId, memberListId);

        return { memberListId, packageId };
    } catch (error) {
        console.error('Error in setupCourseRegistrationFlow:', error);
        throw error;
    }
};

// 6. Get emails from Member List
export const getEmailsFromMemberList = async (
    memberListId: number,
    pageNo = 1,
    pageSize = 50
) => {
    const response = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/v2/member/memberlist/${memberListId}/0`,
        {
            params: { filter: '', pageNo, pageSize },
        }
    );
    return response.data;
};
